import { render, staticRenderFns } from "./BecomeTrader.vue?vue&type=template&id=38b5cccf&scoped=true&"
import script from "./BecomeTrader.vue?vue&type=script&lang=js&"
export * from "./BecomeTrader.vue?vue&type=script&lang=js&"
import style0 from "./BecomeTrader.vue?vue&type=style&index=0&id=38b5cccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5cccf",
  null
  
)

export default component.exports